<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{title}}</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
          </button>
  </div>
  <div class="modal-body">
    {{message}}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark" data-dismiss="modal" (click)="activeModal.close(true)">OK</button>
    <button type="button" class="btn btn-outline-dark" data-dismiss="modal" (click)="activeModal.close(false)">Cancel</button>
  </div>
  